"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeAuthServerResponse = exports.parseOAuth2Fragment = void 0;
/**
 * Creates an object from a string of query parameters.
 */
function parseQueryParametersString(queryParametersString) {
    var queryParametersRegex = /([^&=]+)=([^&]*)/g;
    var queryParameters = {};
    var keyValuePair;
    while ((keyValuePair = queryParametersRegex.exec(queryParametersString))) {
        var key = decodeURIComponent(keyValuePair[1]);
        var value = decodeURIComponent(keyValuePair[2]);
        queryParameters[key] = value;
    }
    return queryParameters;
}
/**
 * Parses an authorization server response.
 */
function parseOAuth2Fragment(fragment) {
    return parseQueryParametersString(fragment.replace(/^#/, ''));
}
exports.parseOAuth2Fragment = parseOAuth2Fragment;
/**
 * Normalizes a parsed authorization server response.
 */
function normalizeAuthServerResponse(authServerResponse) {
    if (authServerResponse.error) {
        var authError = {
            error: authServerResponse.error,
            error_description: authServerResponse.error_description,
            state: authServerResponse.state,
        };
        return authError;
    }
    var expiresIn = parseInt(authServerResponse.expires_in, 10) * 1000;
    var authSuccess = {
        access_token: authServerResponse.access_token,
        expires_in: expiresIn,
        expires_at: Date.now() + expiresIn,
        id_token: authServerResponse.id_token,
        scope: authServerResponse.scope,
        state: authServerResponse.state,
        token_type: authServerResponse.token_type,
        session_state: authServerResponse.session_state,
    };
    return authSuccess;
}
exports.normalizeAuthServerResponse = normalizeAuthServerResponse;
//# sourceMappingURL=SGWTConnectServerResponse.js.map